import {
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { CheckIcon, TruckIcon } from 'lucide-react';
import { FC, memo } from 'react';
import { LaneSummary } from 'src/entities/ShipmentOrderLane';

type Props = {
  summary: LaneSummary | undefined;
  isLoading: boolean;
};

/**
 * レーンサマリーカードコンポーネント
 * 一覧画面上部に表示するサマリー情報
 *
 * 配色は旧 tailwind パレット（未配車=red / 配車済=blue / 完了率=green）を踏襲する。
 * MUI テーマトークン（info.main 等）は色味が異なる（info=緑）ため hex で固定している。
 */
const LaneSummaryCard: FC<Props> = memo(({ summary, isLoading }) => {
  const inHouseTruckRate = summary && summary.laneCount > 0
    ? (summary.inHouseTruckCount / summary.laneCount) * 100
    : 0;
  const partnerTruckRate = summary && summary.laneCount > 0
    ? (summary.partnerTruckCount / summary.laneCount) * 100
    : 0;

  if (isLoading) return null;

  return (
    <Stack direction="row" spacing={4} justifyContent="space-around" alignItems="center" sx={{ height: '100%', pr: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <TruckIcon />
        <Typography>総数:</Typography>
        <Typography sx={{ fontWeight: 'bold' }}>{summary?.laneCount ?? 0}</Typography>
        <Typography>
          (自社: {summary?.inHouseTruckCount ?? 0}台/{inHouseTruckRate}% ,協力: {summary?.partnerTruckCount ?? 0}台/{partnerTruckRate}%)
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ef4444' }} />
        <Typography sx={{ color: '#4b5563' }}>未配車:</Typography>
        <Typography sx={{ fontWeight: 600, color: '#dc2626' }}>{summary?.unassignedLaneCount ?? 0}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#3b82f6' }} />
        <Typography sx={{ color: '#4b5563' }}>配車済:</Typography>
        <Typography sx={{ fontWeight: 600, color: '#2563eb' }}>{summary?.assignedLaneCount ?? 0}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Box component={CheckIcon} sx={{ width: 16, height: 16, color: '#22c55e' }} />
        <Typography sx={{ color: '#4b5563' }}>配車完了率:</Typography>
        <Typography sx={{ fontWeight: 600, color: '#16a34a' }}>{summary?.assignmentRate?.toFixed(0) ?? '0'}%</Typography>
      </Stack>
    </Stack>
  );
});

export default LaneSummaryCard;
